<template>
<nav v-if="totalPages > 1" class="__custom-pagination">
  <ul class="pagination pagination-type-1" :class="[{'pagination-sm': small}, color]">
    <pagination-container
        :number="currentPage" :disabled="currentPage === 1" item-type="Previous"
        icon="fak fa-angle-left-light" className="pagination__borderPrevious" @change-page="changePage"
    />
    <pagination-container
      item-type="Previous" :number="currentPage" :disabled="currentPage === 1"
      :is-mobile="true" class-name="pagination__borderPrevious" @change-page="changePage"
    />
    <pagination-container v-if="currentPage !== 1" :number="1" @change-page="changePage"/>
    <pagination-container v-if="currentPage > 3" item-type="..." :disabled="true" @change-page="changePage"/>
    <pagination-container v-if="needLeftNumber" :number="currentPage-1" @change-page="changePage"/>
    <pagination-container :number="currentPage" :active="true" @change-page="changePage"/>
    <pagination-container v-if="needRightNumber" :number="currentPage+1" @change-page="changePage"/>
    <pagination-container v-if="totalPages-currentPage>=3" item-type="..." :disabled="true" @change-page="changePage"/>
    <pagination-container v-if="currentPage !== totalPages" :number="totalPages" @change-page="changePage" />
    <pagination-container
      item-type="Next" :number="currentPage" :disabled="currentPage === totalPages"
      :is-mobile="true" class-name="pagination__borderNext" @change-page="changePage"
    />
    <pagination-container
        item-type="Next" icon="fak fa-angle-right-light" @change-page="changePage"
        :number="currentPage" :disabled="currentPage === totalPages" class-name="pagination__borderNext"
    />
  </ul>
</nav>
</template>
<script>
  import Vue from "vue";
  import PaginationContainer from "@/components/__new_ui_kit/Pagination/PaginationContainer";
  export default Vue.extend({
    components: {PaginationContainer},
    computed: {
      needLeftNumber(){
        return this.$props.currentPage > 2 && this.$props.currentPage <= 3
      },
      needRightNumber(){
        return this.$props.totalPages - 2 === this.$props.currentPage
      }
    },
    props: {
      currentPage: Number,
      totalPages: Number,
      small: Boolean,
      align: {
        type: String,
        validator(value) {
          return ['start', 'center', 'end'].includes(value)
        },
        default: 'center'
      },
      color: {
        type: String,
        default: 'dark-violet'
      }
    },
    methods: {
      changePage(number) {
        this.$emit('change-page', number)
      }
    }
  })
</script>
<style lang="scss">
;
.__custom-pagination {
  user-select: none;
  .__icon-element {
    display: none;
  }
  a {
    cursor: pointer;
    svg {
      vertical-align: middle;
    }
  }
}

.pagination {
  &__borderNext {
    border-radius: 0 4px 4px 0;
  }

  &__borderPrevious {
    border-radius: 4px 0 0 4px;
  }
}
@media (max-width: 768px) {
  .__custom-pagination {
    .__help-element {
      display: none;
    }

    .__icon-element {
      display: list-item;
    }
  }
}

</style>